import { css } from '@emotion/react'
import { CSSProperties, memo } from 'react'
import Group from '../../../Icons/Group'
import { palette } from '../../../styles/colors'

const groupShowRootStyles = css({
    color: palette.backgroundReverse,
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: 500,
    display: 'flex',
})
const liveStyles = css({ fontWeight: 'bold', color: 'green' })
const pendingStyles = css({ fontWeight: 'bold', color: 'red' })
const iconContainerStyles = css({
    alignItems: 'center',
    display: 'flex',
    '& span': {
        marginLeft: 2,
    },
})

interface GroupShowBannerProps {
    iconSize?: number
    isLive: boolean
    roomCount: number
    styleOverrides?: CSSProperties
}

const GroupShowBanner = memo((props: GroupShowBannerProps) => {
    const { styleOverrides = {}, iconSize, roomCount, isLive } = props

    return (
        <div
            data-testid="Container__GroupShowBanner"
            css={groupShowRootStyles}
            style={styleOverrides}
        >
            <span data-testid="Label_ShowStatus">
                {'Show '}
                {isLive && <span css={liveStyles}>is live!</span>}
                {!isLive && (
                    <>
                        <span css={pendingStyles}>pending.</span>
                    </>
                )}
            </span>
            <span css={iconContainerStyles}>
                <Group size={iconSize} />
                <span>{roomCount}</span>
            </span>
        </div>
    )
})

export default GroupShowBanner
export { GroupShowBanner }
